/**
 * @overview Checkbox component
 */

import React from 'react';
import styled from 'styled-components';

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
`;

// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  height: 1px;
  margin: -1px;
  margin-top:12px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 10px;
  z-index: -1;
  margin-left: 3px;
`;

const getBackgroundColor = (props: IProps) => {
  if (props.checked && !props.disabled) return '#3C419A';
  else if (props.checked && props.disabled) return 'rgb(60, 65, 154, 0.7)';
  else return 'white';
};

const StyledCheckbox = styled.div<IProps>`
  display: flex;
  border-radius: 3px;
  background: ${(props) => getBackgroundColor(props)};

  ${Icon} {
    visibility: ${(props) => (props.checked ? 'visible' : 'hidden')};
  }
`;
interface IProps {
  name?: string;
  flagLabel?: JSX.Element;
  checked: boolean;
  disabled?: boolean;
  className?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Checkbox: React.FC<IProps> = ({name, flagLabel, checked, disabled, className, ...props }) => {
  const content = (
    <CheckboxContainer>
      <HiddenCheckbox checked={checked} {...props} tabIndex={0} />
      <StyledCheckbox checked={checked} disabled={disabled} name={name} flagLabel={flagLabel} {...props} className={className}>
        <Icon viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" strokeWidth="4" />
        </Icon>
      </StyledCheckbox>
    </CheckboxContainer>
  );

  return <label  aria-label='checkbox' style={{display: "inline-flex"}}>{content} {flagLabel} {name}</label>;
};

export default Checkbox;
